import React, { useMemo, useState, Children, memo } from 'react';
import { IconArrowLeft, IconStethoscope, IconSchool, IconFiles, IconShirt, IconChevronRight, IconX, IconPencil, IconCopy, IconPlus, IconToolsKitchen2, IconClock, IconHeart, IconDeviceGamepad2, IconMapPin, IconPhone, IconNotebook, IconSparkles, IconCalendarCheck, IconBell, IconAlertTriangle } from '@tabler/icons-react';
interface ChildDetailPageProps {
  childId: string;
  onAskYeppy?: (childName: string) => void;
}
// Mock Data for Children Details
const mockChildrenData: Record<string, any> = {
  '1': {
    id: '1',
    name: 'Sofia',
    avatar: 'https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg',
    age: 6,
    areas: [{
      id: 'health',
      name: 'Salute',
      icon: IconStethoscope,
      color: '#B0EC9C',
      items: [{
        id: 'h1',
        label: 'Pediatra',
        value: 'Dott.ssa Bianchi',
        type: 'contact'
      }, {
        id: 'h2',
        label: 'Gruppo Sanguigno',
        value: 'A+',
        type: 'text'
      }, {
        id: 'h3',
        label: 'Allergie',
        value: 'Nessuna nota',
        type: 'text'
      }, {
        id: 'h4',
        label: 'Tessera Sanitaria',
        value: '803800005003038589',
        type: 'code'
      }, {
        id: 'h5',
        label: 'Peso',
        value: '22 kg',
        type: 'text'
      }, {
        id: 'h6',
        label: 'Ultimo vaccino',
        value: 'Richiamo DTPa – Mar 2025',
        type: 'text'
      }]
    }, {
      id: 'school',
      name: 'Scuola',
      icon: IconSchool,
      color: '#AEDAFF',
      items: [{
        id: 's1',
        label: 'Scuola',
        value: 'Elementare G. Rodari',
        type: 'text'
      }, {
        id: 's2',
        label: 'Classe',
        value: '1^ B',
        type: 'text'
      }, {
        id: 's3',
        label: 'Maestra prevalente',
        value: 'Laura Verdi',
        type: 'text'
      }, {
        id: 's4',
        label: 'Rappresentante',
        value: 'Giulia (mamma Marco)',
        type: 'contact'
      }, {
        id: 's5',
        label: 'Orario',
        value: '8:30 – 16:00',
        type: 'text'
      }, {
        id: 's6',
        label: 'Mensa',
        value: 'Sì, menu standard',
        type: 'text'
      }]
    }, {
      id: 'docs',
      name: 'Documenti',
      icon: IconFiles,
      color: '#FAD88A',
      items: [{
        id: 'd1',
        label: "Carta d'identità",
        value: 'CA12345AA',
        type: 'code'
      }, {
        id: 'd2',
        label: 'Scadenza C.I.',
        value: '15/05/2028',
        type: 'date'
      }, {
        id: 'd3',
        label: 'Codice Fiscale',
        value: 'RSSSFO18C55H501X',
        type: 'code'
      }, {
        id: 'd4',
        label: 'Passaporto',
        value: 'YA1234567 – scade 2029',
        type: 'code'
      }]
    }, {
      id: 'sizes',
      name: 'Taglie',
      icon: IconShirt,
      color: '#DDD6FE',
      items: [{
        id: 't1',
        label: 'Scarpe',
        value: '32',
        type: 'text'
      }, {
        id: 't2',
        label: 'Altezza',
        value: '118 cm',
        type: 'text'
      }, {
        id: 't3',
        label: 'Vestiti',
        value: '6-7 anni (122cm)',
        type: 'text'
      }, {
        id: 't4',
        label: 'Cappello',
        value: '52 cm',
        type: 'text'
      }]
    }, {
      id: 'food',
      name: 'Alimentazione',
      icon: IconToolsKitchen2,
      color: '#B0EC9C',
      items: [{
        id: 'f1',
        label: 'Intolleranze',
        value: 'Nessuna',
        type: 'text'
      }, {
        id: 'f2',
        label: 'Cibi preferiti',
        value: 'Pasta al pesto, fragole, pizza margherita',
        type: 'text'
      }, {
        id: 'f3',
        label: 'Cibi che non ama',
        value: 'Broccoli, pesce azzurro',
        type: 'text'
      }, {
        id: 'f4',
        label: 'Merenda preferita',
        value: 'Yogurt alla frutta e crackers',
        type: 'text'
      }]
    }, {
      id: 'routine',
      name: 'Abitudini',
      icon: IconClock,
      color: '#AEDAFF',
      items: [{
        id: 'r1',
        label: 'Sveglia',
        value: '7:00',
        type: 'text'
      }, {
        id: 'r2',
        label: 'Nanna',
        value: '20:30',
        type: 'text'
      }, {
        id: 'r3',
        label: 'Pisolino',
        value: 'No',
        type: 'text'
      }, {
        id: 'r4',
        label: 'Attività pomeridiane',
        value: 'Lun: nuoto, Mer: danza',
        type: 'text'
      }]
    }, {
      id: 'preferences',
      name: 'Preferenze',
      icon: IconHeart,
      color: '#FBCFE8',
      items: [{
        id: 'p1',
        label: 'Colore preferito',
        value: 'Viola',
        type: 'text'
      }, {
        id: 'p2',
        label: 'Animale preferito',
        value: 'Gatti',
        type: 'text'
      }, {
        id: 'p3',
        label: 'Cartone preferito',
        value: 'Bluey',
        type: 'text'
      }, {
        id: 'p4',
        label: 'Libro preferito',
        value: 'Il GGG di Roald Dahl',
        type: 'text'
      }, {
        id: 'p5',
        label: 'Musica',
        value: 'Le canzoni di Frozen',
        type: 'text'
      }]
    }, {
      id: 'activities',
      name: 'Attività',
      icon: IconDeviceGamepad2,
      color: '#99F6E4',
      items: [{
        id: 'g1',
        label: 'Gioco preferito',
        value: 'Lego Friends, disegnare',
        type: 'text'
      }, {
        id: 'g2',
        label: 'Giochi da tavolo',
        value: 'Dobble, Uno',
        type: 'text'
      }, {
        id: 'g3',
        label: "Giochi all'aperto",
        value: 'Bicicletta, nascondino',
        type: 'text'
      }, {
        id: 'g4',
        label: 'Videogiochi',
        value: 'No, solo tablet 30min/giorno',
        type: 'text'
      }]
    }, {
      id: 'outings',
      name: 'Uscite',
      icon: IconMapPin,
      color: '#B0EC9C',
      items: [{
        id: 'o1',
        label: 'Parco preferito',
        value: 'Parco della Pellerina',
        type: 'text'
      }, {
        id: 'o2',
        label: 'Ristorante preferito',
        value: 'Pizzeria Da Mario',
        type: 'text'
      }, {
        id: 'o3',
        label: 'Amichette del cuore',
        value: 'Emma, Giulia, Alice',
        type: 'text'
      }, {
        id: 'o4',
        label: 'Posti già visitati',
        value: 'Gardaland, Acquario Genova',
        type: 'text'
      }]
    }, {
      id: 'contacts',
      name: 'Contatti utili',
      icon: IconPhone,
      color: '#AEDAFF',
      items: [{
        id: 'c1',
        label: 'Pediatra',
        value: '011 123 4567',
        type: 'contact'
      }, {
        id: 'c2',
        label: 'Scuola',
        value: '011 987 6543',
        type: 'contact'
      }, {
        id: 'c3',
        label: 'Mamma di Emma',
        value: '340 111 2222',
        type: 'contact'
      }, {
        id: 'c4',
        label: 'Corso nuoto',
        value: '011 555 6666',
        type: 'contact'
      }]
    }, {
      id: 'notes',
      name: 'Note',
      icon: IconNotebook,
      color: '#FAD88A',
      items: [{
        id: 'n1',
        label: 'Paure',
        value: 'Ha paura del buio, usa lucina notturna',
        type: 'text'
      }, {
        id: 'n2',
        label: 'Carattere',
        value: "Socievole, creativa, un po' timida con gli adulti",
        type: 'text'
      }, {
        id: 'n3',
        label: 'Da ricordare',
        value: 'Ama le sorprese, non le piace essere svegliata di fretta',
        type: 'text'
      }]
    }]
  },
  '2': {
    id: '2',
    name: 'Marco',
    avatar: 'https://cdn.magicpatterns.com/uploads/1EXQ4FkeqG6UuqJKWikck9/tatev-arsh-ZtB5Haz58os-unsplash.jpg',
    age: 4,
    areas: [{
      id: 'health',
      name: 'Salute',
      icon: IconStethoscope,
      color: '#B0EC9C',
      items: [{
        id: 'h1',
        label: 'Pediatra',
        value: 'Dott.ssa Bianchi',
        type: 'contact'
      }, {
        id: 'h2',
        label: 'Gruppo Sanguigno',
        value: '0+',
        type: 'text'
      }, {
        id: 'h3',
        label: 'Allergie',
        value: 'Lattosio (lieve)',
        type: 'text'
      }, {
        id: 'h4',
        label: 'Peso',
        value: '16 kg',
        type: 'text'
      }]
    }, {
      id: 'school',
      name: 'Asilo',
      icon: IconSchool,
      color: '#AEDAFF',
      items: [{
        id: 's1',
        label: 'Scuola',
        value: 'Materna Arcobaleno',
        type: 'text'
      }, {
        id: 's2',
        label: 'Sezione',
        value: 'Gialli',
        type: 'text'
      }, {
        id: 's3',
        label: 'Maestra',
        value: 'Maestra Anna',
        type: 'text'
      }, {
        id: 's4',
        label: 'Orario',
        value: '8:00 – 16:00',
        type: 'text'
      }]
    }, {
      id: 'docs',
      name: 'Documenti',
      icon: IconFiles,
      color: '#FAD88A',
      items: [{
        id: 'd1',
        label: 'Codice Fiscale',
        value: 'RSSMRC20L22H501Y',
        type: 'code'
      }, {
        id: 'd2',
        label: 'Tessera Sanitaria',
        value: '803800005003099123',
        type: 'code'
      }, {
        id: 'd3',
        label: 'Passaporto',
        value: 'Da fare',
        type: 'text'
      }]
    }, {
      id: 'sizes',
      name: 'Taglie',
      icon: IconShirt,
      color: '#DDD6FE',
      items: [{
        id: 't1',
        label: 'Scarpe',
        value: '28',
        type: 'text'
      }, {
        id: 't2',
        label: 'Altezza',
        value: '104 cm',
        type: 'text'
      }, {
        id: 't3',
        label: 'Vestiti',
        value: '4-5 anni (110cm)',
        type: 'text'
      }]
    }, {
      id: 'food',
      name: 'Alimentazione',
      icon: IconToolsKitchen2,
      color: '#B0EC9C',
      items: [{
        id: 'f1',
        label: 'Intolleranze',
        value: 'Lattosio (lieve)',
        type: 'text'
      }, {
        id: 'f2',
        label: 'Cibi preferiti',
        value: 'Riso, polpette, banana',
        type: 'text'
      }, {
        id: 'f3',
        label: 'Mensa',
        value: 'Sì, menu senza lattosio',
        type: 'text'
      }]
    }, {
      id: 'routine',
      name: 'Abitudini',
      icon: IconClock,
      color: '#AEDAFF',
      items: [{
        id: 'r1',
        label: 'Sveglia',
        value: '7:30',
        type: 'text'
      }, {
        id: 'r2',
        label: 'Nanna',
        value: '20:00',
        type: 'text'
      }, {
        id: 'r3',
        label: 'Pisolino',
        value: '14:00 – 15:30',
        type: 'text'
      }]
    }, {
      id: 'preferences',
      name: 'Preferenze',
      icon: IconHeart,
      color: '#FBCFE8',
      items: [{
        id: 'p1',
        label: 'Colore preferito',
        value: 'Rosso',
        type: 'text'
      }, {
        id: 'p2',
        label: 'Animale preferito',
        value: 'Dinosauri',
        type: 'text'
      }, {
        id: 'p3',
        label: 'Cartone preferito',
        value: 'Paw Patrol',
        type: 'text'
      }, {
        id: 'p4',
        label: 'Peluche preferito',
        value: 'Rex il dinosauro verde',
        type: 'text'
      }]
    }, {
      id: 'activities',
      name: 'Attività',
      icon: IconDeviceGamepad2,
      color: '#99F6E4',
      items: [{
        id: 'g1',
        label: 'Gioco preferito',
        value: 'Macchinine, costruzioni Duplo',
        type: 'text'
      }, {
        id: 'g2',
        label: "Giochi all'aperto",
        value: 'Pallone, scivolo',
        type: 'text'
      }, {
        id: 'g3',
        label: 'Attività creative',
        value: 'Colorare, plastilina',
        type: 'text'
      }]
    }, {
      id: 'outings',
      name: 'Uscite',
      icon: IconMapPin,
      color: '#B0EC9C',
      items: [{
        id: 'o1',
        label: 'Parco preferito',
        value: 'Parco del Valentino',
        type: 'text'
      }, {
        id: 'o2',
        label: 'Amichetti',
        value: 'Tommaso, Leo',
        type: 'text'
      }]
    }, {
      id: 'contacts',
      name: 'Contatti utili',
      icon: IconPhone,
      color: '#AEDAFF',
      items: [{
        id: 'c1',
        label: 'Pediatra',
        value: '011 123 4567',
        type: 'contact'
      }, {
        id: 'c2',
        label: 'Asilo',
        value: '011 222 3333',
        type: 'contact'
      }]
    }, {
      id: 'notes',
      name: 'Note',
      icon: IconNotebook,
      color: '#FAD88A',
      items: [{
        id: 'n1',
        label: 'Carattere',
        value: 'Energico, curioso, ama esplorare',
        type: 'text'
      }, {
        id: 'n2',
        label: 'Da ricordare',
        value: 'Usa ancora il ciuccio per dormire, doudou blu indispensabile',
        type: 'text'
      }]
    }]
  }
};
const mockUpcoming: Record<string, any[]> = {
  '1': [{
    id: 'u1',
    title: 'Saggio di danza',
    date: '15 Feb',
    daysLeft: 9,
    color: '#DDD6FE'
  }, {
    id: 'u2',
    title: 'Scadenza iscrizione mensa',
    date: '20 Feb',
    daysLeft: 14,
    color: '#FAD88A'
  }, {
    id: 'u3',
    title: 'Controllo dentista',
    date: '5 Mar',
    daysLeft: 27,
    color: '#B0EC9C'
  }],
  '2': [{
    id: 'u1',
    title: 'Festa di carnevale asilo',
    date: '12 Feb',
    daysLeft: 6,
    color: '#AEDAFF'
  }, {
    id: 'u2',
    title: 'Visita oculistica',
    date: '28 Feb',
    daysLeft: 22,
    color: '#B0EC9C'
  }]
};
const mockReminders: Record<string, any[]> = {
  '1': [{
    id: 'r1',
    text: 'Portare certificato medico a scuola',
    urgent: true
  }, {
    id: 'r2',
    text: 'Comprare quaderni nuovi',
    urgent: false
  }, {
    id: 'r3',
    text: 'Prenotare campo estivo',
    urgent: false
  }],
  '2': [{
    id: 'r1',
    text: 'Portare doudou blu al lavaggio',
    urgent: true
  }, {
    id: 'r2',
    text: 'Comprare pannolini per pisolino asilo',
    urgent: false
  }]
};
const getIconForType = (type: string) => {
  switch (type) {
    case 'doctor':
      return <IconStethoscope className="w-4 h-4" stroke={1.5} data-id="element-665" />;
    case 'school':
      return <IconSchool className="w-4 h-4" stroke={1.5} data-id="element-666" />;
    case 'location':
      return <IconMapPin className="w-4 h-4" stroke={1.5} data-id="element-667" />;
    case 'contact':
      return <IconPhone className="w-4 h-4" stroke={1.5} data-id="element-668" />;
    case 'note':
      return <IconNotebook className="w-4 h-4" stroke={1.5} data-id="element-669" />;
    case 'alert':
      return <IconAlertTriangle className="w-4 h-4" stroke={1.5} data-id="element-670" />;
    case 'date':
      return <IconCalendarCheck className="w-4 h-4" stroke={1.5} data-id="element-671" />;
    case 'time':
      return <IconClock className="w-4 h-4" stroke={1.5} data-id="element-672" />;
    case 'food':
      return <IconToolsKitchen2 className="w-4 h-4" stroke={1.5} data-id="element-673" />;
    case 'size':
      return <IconShirt className="w-4 h-4" stroke={1.5} data-id="element-674" />;
    case 'doc':
      return <IconFiles className="w-4 h-4" stroke={1.5} data-id="element-675" />;
    case 'heart':
      return <IconHeart className="w-4 h-4" stroke={1.5} data-id="element-676" />;
    case 'activity':
      return <IconDeviceGamepad2 className="w-4 h-4" stroke={1.5} data-id="element-677" />;
    default:
      return <IconNotebook className="w-4 h-4" stroke={1.5} data-id="element-678" />;
  }
};
export function ChildDetailPage({
  childId,
  onAskYeppy
}: ChildDetailPageProps) {
  const [selectedAreaId, setSelectedAreaId] = useState<string | null>(null);
  const child = mockChildrenData[childId] || mockChildrenData['1'];
  const selectedArea = child.areas.find((a: any) => a.id === selectedAreaId);
  const upcoming = mockUpcoming[childId] || mockUpcoming['1'];
  const reminders = mockReminders[childId] || mockReminders['1'];
  const quickInfo = useMemo(() => {
    const getItem = (areaId: string, label: string) => {
      const area = child.areas.find((a: any) => a.id === areaId);
      if (!area) return null;
      return area.items.find((i: any) => i.label === label);
    };
    return {
      school: getItem('school', 'Scuola') || getItem('school', 'Scuola'),
      class: getItem('school', 'Classe') || getItem('school', 'Sezione'),
      schedule: getItem('school', 'Orario'),
      pediatra: getItem('health', 'Pediatra'),
      allergies: getItem('health', 'Allergie') || getItem('health', 'Intolleranze') || getItem('food', 'Intolleranze'),
      bedtime: getItem('routine', 'Nanna')
    };
  }, [child]);
  const totalInfoCount = useMemo(() => {
    return child.areas.reduce((sum: number, area: any) => sum + area.items.length, 0);
  }, [child]);
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
  };
  return <div className="flex flex-col h-full bg-yeppy-bg" data-id="element-679">
      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-4" data-id="element-680">
        {selectedAreaId /* VIEW: Area Detail */ ? <div className="space-y-4 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-681">
            {/* Area Header */}
            

            {selectedArea.items.map((item: any) => <div key={item.id} className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 flex items-center justify-between group" data-id="element-682">
                {/* ... existing code ... */}
                <div data-id="element-683">
                  <p className="font-poppins text-xs text-yeppy-text text-opacity-50 mb-1" data-id="element-684">
                    {item.label}
                  </p>
                  <p className="font-poppins text-base text-yeppy-text font-medium select-all" data-id="element-685">
                    {item.value}
                  </p>
                </div>
                <div className="flex items-center gap-2 opacity-100 md:opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-686">
                  <button onClick={() => handleCopy(item.value)} className="w-8 h-8 flex items-center justify-center rounded-full bg-yeppy-bg text-yeppy-text text-opacity-60 hover:bg-yeppy-text hover:text-white transition-colors" data-id="element-687">
                    <IconCopy className="w-4 h-4" stroke={1.5} data-id="element-688" />
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center rounded-full bg-yeppy-bg text-yeppy-text text-opacity-60 hover:bg-yeppy-text hover:text-white transition-colors" data-id="element-689">
                    <IconPencil className="w-4 h-4" stroke={1.5} data-id="element-690" />
                  </button>
                </div>
              </div>)}
            <button className="w-full py-4 rounded-2xl border-2 border-dashed border-yeppy-text border-opacity-20 flex items-center justify-center gap-2 text-yeppy-text text-opacity-50 hover:bg-white hover:border-opacity-30 transition-all" data-id="element-691">
              <IconPlus className="w-5 h-5" stroke={1.5} data-id="element-692" />
              <span className="font-poppins text-sm font-medium" data-id="element-693">
                Aggiungi informazione
              </span>
            </button>
          </div> /* UNIFIED VIEW: CTA → Overview → Categories */ : <div className="space-y-5 animate-in fade-in duration-200" data-id="element-694">
            {/* Profile Hero */}
            <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 flex items-center gap-4" data-id="element-695">
              <img src={child.avatar} alt={child.name} className="w-16 h-16 rounded-full object-cover border-2 border-yeppy-text border-opacity-10" data-id="element-696" />
              <div data-id="element-697">
                <h2 className="font-rubik font-bold text-lg text-yeppy-text leading-tight" data-id="element-698">
                  {child.name}
                </h2>
                <p className="font-poppins text-sm text-yeppy-text text-opacity-60 mt-0.5" data-id="element-699">
                  {child.age} anni · {totalInfoCount} info salvate
                </p>
              </div>
            </div>

            {/* 1. CTA - Chiedi a Yeppy */}
            <button onClick={() => onAskYeppy?.(child.name)} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl bg-white border border-yeppy-text border-opacity-15 text-yeppy-text font-poppins text-sm font-semibold transition-all active:scale-[0.98] shadow-sm" data-id="element-700">
              <IconSparkles className="w-5 h-5 text-yeppy-blue" stroke={1.5} data-id="element-701" />
              Chiedi a Yeppy
            </button>

            {/* 2. Categories list */}
            <div data-id="element-702">
              <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40 mb-2" data-id="element-703">
                Categorie
              </h2>
              <div className="space-y-3" data-id="element-704">
                {child.areas.map((area: any) => {
              const Icon = area.icon;
              return <button key={area.id} onClick={() => setSelectedAreaId(area.id)} className="w-full bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 flex items-center gap-4 text-left active:scale-[0.98] transition-transform" data-id="element-705">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: `${area.color}33`
                }} data-id="element-706">
                        <Icon className="w-5 h-5" stroke={1.5} style={{
                    color: '#1D2A36'
                  }} data-id="element-707" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-708">
                        <h3 className="font-rubik font-semibold text-sm text-yeppy-text" data-id="element-709">
                          {area.name}
                        </h3>
                        <p className="font-poppins text-xs text-yeppy-text text-opacity-50" data-id="element-710">
                          {area.items.length} informazioni
                        </p>
                      </div>
                      <IconChevronRight className="w-5 h-5 text-yeppy-text text-opacity-30" stroke={1.5} data-id="element-711" />
                    </button>;
            })}
                <button className="w-full py-4 rounded-2xl border-2 border-dashed border-yeppy-text border-opacity-20 flex items-center justify-center gap-2 text-yeppy-text text-opacity-50 hover:bg-white hover:border-opacity-30 transition-all" data-id="element-712">
                  <IconPlus className="w-5 h-5" stroke={1.5} data-id="element-713" />
                  <span className="font-poppins text-sm font-medium" data-id="element-714">
                    Nuova area
                  </span>
                </button>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}